import { AxiosRequestConfig } from 'axios'

export interface ParticipationByLevelParams {
  startDate: string
  endDate: string
  storeId?: string | number
  userType?: 'all' | 'recurrent'
}

export interface ParticipationLevelData {
  id: number
  nivel: number
  visitors: number
  visits: number
}

const getParticipationByLevel = (params: ParticipationByLevelParams): AxiosRequestConfig => ({
  url: '/dashboard/participation-by-level',
  method: 'GET',
  params,
})

export { getParticipationByLevel }
